<app-item>
	@if (viewModel.sections.length > 1) {
		<app-item-button (click)="expandCollapseSections(true)">Expand all</app-item-button>
		<app-item-button (click)="expandCollapseSections(false)">Collapse all</app-item-button>
	}
</app-item>